import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, tap } from 'rxjs';
import { ReleaseNoteModel } from '@app/models/release-note-model';

@Injectable({
  providedIn: 'root'
})
export class UtilityService extends BaseService {
    readonly BASE_URL = `${environment.gatewayAPI_V1}/utilities/`;
  constructor(private httpClient: HttpClient) {
    super();
  }

  public getReleaseNote(applicationName: string): Observable<ReleaseNoteModel | null> {
      
    const url = `${this.BASE_URL}api/ReleaseNote?application=${applicationName}`;
     
    return this.httpClient.get<ReleaseNoteModel>(url).pipe(
      tap(_ => _), catchError(this.handleError)
      );
  }
  
}
